
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Cocktails from './cocktails';
import EventsScreen from './events';
import ListProducts from './ListProducts';
import ColdDrinks from './colddrinks';
import Alcoholic from './alcoholic';
import BottleScreen from './bottle';
import BeerScreen from './beers';

function Index({setShowHappy}) {

     const {change, getInitData} = useRefresh();

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [hotdrinks, sethotdrinks] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showColdDrinks, setShowColdDrinks] = useState(false);
    const [showAlcoholic, setShowAlcoholic] = useState(false);
    const [showBottle, setShowBottle] = useState(false);
    const [showBeers, setShowBeers] = useState(false);
       const [colddrinks, setcolddrinks] = useState(false);
    

     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);

     useEffect(() => {
            menus.map((item) => {
            if (item.id === 927) {
                sethotdrinks(item);
            }
                if (item.id === 943) {
                setcolddrinks(item);
            }
        });
    }, [menus]);



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy} setShowColdDrinks={setShowColdDrinks}>
                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', justifyContent: "center",alignItems: 'center'}}>
                    <div style={{ width: '100%', marginBottom: 2, position: 'relative', marginTop: 200 }}>
                        
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 300,
                                height: 85,
                                position: 'relative',
                                cursor: 'pointer',
                                backgroundImage: `url(${require('./assets/BOTON1.png')})`,
                                backgroundPosition: 'center',
                                backgroundSize: '100% 100%',
                                backgroundRepeat: 'no-repeat',
                                opacity: 1,
                                margin: "0 auto"
                            }}
                            onClick={() => {
                               
                                
                            }}
                        >
                                <p
                                    style={{
                                        color: '#fff',
                                        fontSize: 30,
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Bebas_Neue',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                       
                                    }}
                                >
                                Bebidas Frias
                                </p>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 300,
                                height: 85,
                                position: 'relative',
                                cursor: 'pointer',
                                backgroundImage: `url(${require('./assets/BOTON1.png')})`,
                                backgroundPosition: 'center',
                                backgroundSize: '100% 100%',
                                backgroundRepeat: 'no-repeat',
                                opacity: 1,
                                margin: "0 auto",
                                marginTop: 20
                            }}
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(hotdrinks)
                            }}
                        >
                                <p
                                    style={{
                                        color: '#fff',
                                        fontSize: 30,
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Bebas_Neue',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                       
                                    }}
                                >
                                Bebidas Calientes
                                </p>
                        </div>

                         <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 230,
                                height: 85,
                                position: 'relative',
                                cursor: 'pointer',
                                backgroundImage: `url(${require('./assets/BOTON1.png')})`,
                                backgroundPosition: 'center',
                                backgroundSize: '100% 100%',
                                backgroundRepeat: 'no-repeat',
                                opacity: 1,
                                margin: "0 auto",
                                marginTop: 20
                            }}
                            onClick={() => {
                                 setShowListProduct(true)
                                setdishs(colddrinks)
                            }}
                        >
                                <p
                                    style={{
                                        color: '#fff',
                                        fontSize: 30,
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Bebas_Neue',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                       
                                    }}
                                >
                                Cócteles
                                </p>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 230,
                                height: 85,
                                position: 'relative',
                                cursor: 'pointer',
                                backgroundImage: `url(${require('./assets/BOTON1.png')})`,
                                backgroundPosition: 'center',
                                backgroundSize: '100% 100%',
                                backgroundRepeat: 'no-repeat',
                                opacity: 1,
                                margin: "0 auto",
                                marginTop: 20
                            }}
                            onClick={() => {
                                setShowBeers(true)
                            }}
                        >
                                <p
                                    style={{
                                        color: '#fff',
                                        fontSize: 30,
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Bebas_Neue',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                       
                                    }}
                                >
                                Cervezas
                                </p>
                        </div>

                        
                       
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showColdDrinks && <ColdDrinks setShowHappy={setShowColdDrinks} />}
                {showAlcoholic && <Alcoholic setShowHappy={setShowAlcoholic} />}
                {showBottle && <BottleScreen setShowHappy={setShowBottle} />}
                {showBeers && <BeerScreen setShowHappy={setShowBeers} />}
                 {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;